<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="true"
    :nudge-width="200"
    offset-y
    min-width="300px"
  >
    <template v-slot:activator="{ on }">
      <v-avatar
        v-on="on"
        v-if="user"
        style="cursor: pointer"
      >
        <img
          :src="firebaseUser.photoURL"
          :alt="firebaseUser.displayName"
        >
      </v-avatar>
    </template>
    <v-card>
      <v-list>
        <v-list-item>
          <paow-facebook-login-button
            :x-large-button="true"
            :large-icon="true"
          />
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>

</template>

<script>
import { mapState } from 'vuex'
import firebaseUser from '../mixins/firebaseUser'
import PaowFacebookLoginButton from './PaowFacebookLoginButton'

export default {
  name: 'PaowUserAvatar',
  mixins: [firebaseUser],
  components: {
    PaowFacebookLoginButton
  },
  data () {
    return {
      menu: this.user
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.status
    })
  }
}
</script>

<style scoped>

</style>
